import { makeAutoObservable } from "mobx";
import { IRmaError } from "../rma-types";

class RmaErrorListStore {
    private _model: IRmaError[] = [];
    constructor(model: IRmaError[]) {
        /* Sort the errors by id in descending order. */
        this._model = model.sort((a, b) => b.id - a.id);
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get lastUnresolvedShortError(): string | undefined {
        const error = this._model.find(err => !err.is_resolved && err.short_error);
        return error?.short_error ?? undefined;
    }

}

export default RmaErrorListStore;